import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import type { IMemberPapers } from "@api/members/papers/routeType";
import { useGetAllMemberPapers } from "@api/members/papers/getAll";
import { useGetMemberPaper } from "@api/members/papers/get";

const { getPath } = getApi("members.papers.put");

type IExtractedRouteType = IMemberPapers["paperSingleUpdate"];

export type IPutMemberPaper = IPickMutation<IExtractedRouteType>;

const putMemberPaper: MutationFunction<
  IPutMemberPaper["response"],
  IPutMemberPaper["variables"]
> = ({ memberId, paperId, ...data }) => {
  return axiosClient.put(getPath({ memberId, paperId }), data);
};

export const usePutMemberPaper = createMutation({
  mutationFn: putMemberPaper,
  onSuccess: (_, { memberId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetAllMemberPapers.getKey(),
    });
    queryClient.invalidateQueries({
      queryKey: useGetMemberPaper.getKey({ memberId }),
    });
  },
});
